import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalProps } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

interface Props extends BaseModalProps {
  title: string
  description: string
  onConfirm: () => void
}

export const ActionModal: React.FC<Props> = (props) => {
  const { close, onConfirm } = props
  const { t } = useTranslation()
  const { title = t('Cancel?') } = props
  const { description = t('Are you sure you want to cancel') } = props

  const handleExit = async () => {
    await close()
    onConfirm()
  }

  return (
    <Modal>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>{description}</Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('No')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary onClick={handleExit}>{t('Yes')}</Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
